import * as Api from '@ViewModels';
import * as React from 'react';
import { toast } from 'sonner';
import { useArchiveInsurancePolicyMutation, useDeleteDonationMutation } from '../../../../queries';
import { DeleteConfirmation } from '../../DeleteConfirmation';

export enum DeleteType {
	Policy = 'policy',
	Donation = 'donation',
}

export const DeleteModal = ({
	item,
	isOpen,
	setIsOpen,
	onConfirm,
	type,
}: {
	item: Api.IDonation | Api.IInsurancePolicy;
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	onConfirm: () => void;
	type: DeleteType;
}) => {
	const [isDeleting, setIsDeleting] = React.useState(false);

	const deleteDonationMutation = useDeleteDonationMutation({
		onSuccess: () => {
			toast.success('Donation successfully deleted');
			onConfirm();
		},
	});
	const archivePolicyMutation = useArchiveInsurancePolicyMutation({
		onSuccess: () => {
			toast.success('Policy successfully archived');
			onConfirm();
		},
	});

	const confirm = async () => {
		if (type === DeleteType.Donation) {
			await deleteDonationMutation.mutateAsync({
				donationId: item.id,
			});
		} else if (DeleteType.Policy) {
			await archivePolicyMutation.mutateAsync({
				policyId: item.id,
			});
		}
		setIsDeleting(false);
	};

	const cancel = () => {
		setIsOpen(false);
		setIsDeleting(false);
	};

	const onFinish = (confirmDelete: boolean) => {
		setIsDeleting(true);
		if (confirmDelete) {
			confirm();
		} else {
			cancel();
		}
	};

	const message = `Are you sure you want to delete this ${type}?`;

	return <DeleteConfirmation bodyText={message} isOpen={isOpen} onFinish={onFinish} showSpinner={isDeleting} />;
};
